module.exports = __webpack_public_path__ + "components/page-footer/static/mountain-forecast__logo--white-c0ba99782c59a80dbb1390095b28abad.png";